<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ser"><img alt="9781618371621_0036_001" src="Images/9781618371621_0036_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1064236"><i>Potato Halves with Smoked Salmon and Dill </i></p>
<p class="h1" id="d7e1064736" style="color: #82a339"><b>POTATO HALVES WITH <br/> SMOKED SALMON AND DILL</b></p>
<p class="ext" id="d7e1065536"><b><i>For ease of arranging and serving, cut a thin slice from the rounded side of each potato half before steaming so it will sit flat on your serving platter.</i></b></p>
<p class="h4" id="d7e1066836" style="color: #496210"><b>Prep: 20 minutes     Cook: 10 minutes</b></p>
<p class="ul" id="d7e1067436">18 baby red potatoes (1½ pounds), cut in half</p>
<p class="ul" id="d7e1068536">2 tablespoons water</p>
<p class="ul" id="d7e1068836">1 tablespoon olive oil</p>
<p class="ul" id="d7e1069136">½ teaspoon salt</p>
<p class="ul" id="d7e1070136">¼ teaspoon coarsely ground black pepper</p>
<p class="ul" id="d7e1071036">¼ cup reduced-fat sour cream</p>
<p class="ul" id="d7e1072036">4 ounces sliced smoked salmon, cut into 36 pieces</p>
<p class="ul" id="d7e1072336">1 tablespoon snipped fresh dill</p>
<p class="pub" id="d7e1072836" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In microwave-safe large bowl, place potatoes and water. Cover bowl with vented plastic wrap, and microwave on High 5 to 6 minutes or until just fork-tender.</p>
<p class="pub" id="d7e1074136"><span style="color: #c15b49"><b>2.</b></span> Meanwhile, prepare outdoor grill for direct grilling over medium heat.</p>
<p class="pub" id="d7e1075236"><span style="color: #c15b49"><b>3.</b></span> Transfer potatoes to jelly-roll pan. Brush potatoes all over with olive oil, and sprinkle with salt and pepper. Place potatoes on hot grill grate; cook 5 to 6 minutes or until lightly charred on both sides, turning once.</p>
<p class="pub" id="d7e1077136"><span style="color: #c15b49"><b>4.</b></span> Arrange potato halves, rounded sides down, on serving plate. Top each with about ¼ teaspoon sour cream, 1 piece salmon, and some dill. Makes 12 appetizer servings.</p>
<p class="ntx" id="d7e1079836">Each serving: About 75 calories, 3g protein, 12g carbohydrate, 2g total fat (1g saturated), 1g fiber, 4mg cholesterol, 290mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c22_r1.vue?0318ae05